export default __webpack_public_path__ + "static/naan_thumb-da96f013963f17c5a7e7096e6b09b964.jpg";